var React = require('react');

function Monitor (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M20.1079 28.8333V35.4999","stroke":"#01C716","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M33.4414 5.5H6.77474C4.93379 5.5 3.44141 6.99238 3.44141 8.83333V25.5C3.44141 27.3409 4.93379 28.8333 6.77474 28.8333H33.4414C35.2824 28.8333 36.7747 27.3409 36.7747 25.5V8.83333C36.7747 6.99238 35.2824 5.5 33.4414 5.5Z","stroke":"#01C716","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M13.4414 35.5H26.7747","stroke":"#01C716","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Monitor.defaultProps = {"width":"41","height":"41","viewBox":"0 0 41 41","fill":"none"};

module.exports = Monitor;

Monitor.default = Monitor;
